import { put, all, retry } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { authClient } from '../api/Client';
import { NOTIFICATION } from '../constants';
import { errorNotification } from '../../shared-components/Notifications';
import { selectBulkDataFeeds } from '../selectors/bulkdata';
import { saveAs } from 'file-saver';

export function* loadBulkDataFeeds({ filterParams }) {
  try {
    const res = yield retry(4, 500, authClient?.Bulkdata?.loadBulkDataFeeds, {
      filterParams,
    });

    yield put({
      type: resolve(types?.LOAD_BULK_DATA_FEEDS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_BULK_DATA_FEEDS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_BULK_DATA_FEEDS),
        ),
      }),
    ]);
  }
}

export function* loadBulkDataFeedOptions() {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Bulkdata?.loadBulkDataFeedOptions,
    );

    yield put({
      type: resolve(types?.LOAD_BULK_DATA_FEED_OPTIONS),
      payload: selectBulkDataFeeds(res?.data()),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_BULK_DATA_FEED_OPTIONS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.LOAD_BULK_DATA_FEED_OPTIONS),
        ),
      }),
    ]);
  }
}

export function* downloadBulkDataFeed({ filename }) {
  try {
    const res = yield retry(4, 500, authClient?.Bulkdata.downloadBulkDataFeed, {
      filename,
    });
    yield put({
      type: resolve(types?.DOWNLOAD_BULK_DATA_FEED),
      payload: res?.data()?.link,
    });
  } catch (error) {
    yield put({
      type: reject(types?.DOWNLOAD_BULK_DATA_FEED),
      notification: errorNotification(
        error,
        reject(types?.DOWNLOAD_BULK_DATA_FEED),
      ),
    });
  }
}
